/**
 * PURPOSE: represents the business line category options as an enum
 */
export enum BusinessLineCategoryEnum {
  COMMERCIAL = "COMMERCIAL",
  PERSONAL = "PERSONAL",
  LIFE_ANNUITIES = "LIFE_ANNUITIES"
}
